export default class UnauthenticatedError extends Error {}
